// Catalogue complet des aéronefs PRESTACO - 60 modèles (6 par catégorie × 10 catégories)

export const aircraftData = {
  transportLight: [
    { 
      id: 'cessna-c208-grand-caravan',
      name: 'Cessna C-208 Grand Caravan EX', 
      country: 'États-Unis', 
      range: '1 700 km', 
      capacity: '8-12 pax', 
      role: 'Transport léger, EVASAN, liaison',
      mtow: '3 969 kg',
      speed: '344 km/h',
      ceiling: '25 000 ft',
      crew: '1-2 pilotes',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-114A',
      payload: '1 588 kg',
      features: ['Capacités STOL', 'Version amphibie disponible', 'Très fiable', 'Maintenance simple'],
      description: 'Le Cessna C-208 Grand Caravan est un avion utilitaire monomoteur turbopropulsé extrêmement polyvalent. Reconnu pour sa fiabilité exceptionnelle et ses faibles coûts d\'exploitation, il excelle dans les missions de transport léger, les évacuations sanitaires et les liaisons régionales.',
      image: 'https://images.unsplash.com/photo-1631044071108-1c9efed7101b?auto=format&fit=crop&q=80'
    },
    { 
      id: 'pilatus-pc12-ngx',
      name: 'Pilatus PC-12 NGX', 
      country: 'Suisse', 
      range: '3 300 km', 
      capacity: '6-8 pax', 
      role: 'Liaison, missions spéciales, EVASAN',
      mtow: '4 740 kg',
      speed: '520 km/h',
      ceiling: '30 000 ft',
      crew: '1-2 pilotes',
      engine: '1 × turbopropulseur Pratt & Whitney PT6E-67XP',
      payload: '1 247 kg',
      features: ['Avionique dernière génération', 'Cabine pressurisée', 'Grande polyvalence', 'Coûts réduits'],
      description: 'Le Pilatus PC-12 NGX représente l\'évolution ultime de cette famille d\'avions monomoteurs. Équipé d\'une avionique ultra-moderne et d\'une cabine spacieuse pressurisée, il offre performance, confort et polyvalence inégalés.',
      image: 'https://images.unsplash.com/photo-1693835195915-b30cc5ae885c?auto=format&fit=crop&q=80'
    },
    { 
      id: 'viking-dhc6-twin-otter',
      name: 'Viking DHC-6-400 Twin Otter', 
      country: 'Canada', 
      range: '1 400-1 500 km', 
      capacity: 'jusqu\'à 19 pax', 
      role: 'Transport utilitaire, opérations STOL, zones isolées',
      mtow: '5 670 kg',
      speed: '315-335 km/h',
      ceiling: '25 000 ft',
      crew: '1-2 pilotes',
      engine: '2 × turbopropulseurs Pratt & Whitney PT6A-34/35',
      payload: '2 500 kg',
      features: ['Capacités STOL exceptionnelles', 'Pistes courtes/non préparées', 'Très robuste', 'Idéal zones rurales'],
      description: 'Le Twin Otter est légendaire pour ses capacités STOL (Short Take-Off and Landing). Capable d\'opérer sur des pistes extrêmement courtes et non préparées, il est idéal pour desservir zones isolées, îles et terrains improvisés.',
      image: 'https://images.pexels.com/photos/35192322/pexels-photo-35192322.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'beechcraft-king-air-350i',
      name: 'Beechcraft King Air 350i', 
      country: 'États-Unis', 
      range: '3 300 km', 
      capacity: '8-11 pax', 
      role: 'Transport léger/moyen, liaisons, versions ISR ou MPA légères',
      mtow: '6 800 kg',
      speed: '575-585 km/h',
      ceiling: '35 000 ft',
      crew: '1-2 pilotes',
      engine: '2 × turbopropulseurs Pratt & Whitney PT6A-60A',
      payload: '2 300 kg',
      features: ['Bimoteur éprouvé', 'Excellent compromis sécurité/performance', 'Versions spéciales possibles', 'Très répandu'],
      description: 'Le King Air 350i est un bimoteur de référence offrant un excellent compromis entre sécurité, performance et coûts. Avec de nombreuses possibilités de configurations spéciales (surveillance, reconnaissance, médicalisation), c\'est une plateforme très polyvalente.',
      image: 'https://images.unsplash.com/photo-1660968601185-e7414de388f4?auto=format&fit=crop&q=80'
    },
    { 
      id: 'let-l410-ng',
      name: 'Let L-410 NG', 
      country: 'Tchéquie', 
      range: '2 500-2 600 km', 
      capacity: '19 pax', 
      role: 'Transport régional, conditions climatiques difficiles',
      mtow: '7 000 kg',
      speed: '410-420 km/h',
      ceiling: '25 000 ft',
      crew: '2 pilotes',
      engine: '2 × turbopropulseurs GE H85-200',
      payload: '2 200-2 300 kg',
      features: ['Version modernisée', 'Avionique récente', 'Robuste', 'Environnements chauds'],
      description: 'Version modernisée du célèbre L-410, le NG bénéficie d\'une avionique récente et d\'une robustesse éprouvée. Particulièrement adapté aux environnements chauds et poussiéreux, idéal pour l\'Afrique.',
      image: 'https://images.unsplash.com/photo-1680702344590-822c423cbc16?auto=format&fit=crop&q=80'
    },
    { 
      id: 'cessna-408-skycourier',
      name: 'Cessna 408 SkyCourier', 
      country: 'États-Unis', 
      range: '1 600 km', 
      capacity: '19 pax', 
      role: 'Transport passagers/fret',
      mtow: '8 392 kg',
      speed: '370 km/h',
      ceiling: '25 000 ft',
      crew: '1-2 pilotes',
      engine: '2 × turbopropulseurs Pratt & Whitney PT6A-65SC',
      payload: '2 722 kg',
      features: ['Grande porte cargo', 'Configuration flexible', 'Économique', 'Maintenance simplifiée'],
      description: 'Le SkyCourier est un bimoteur moderne conçu spécifiquement pour le transport de passagers et de fret. Sa grande porte cargo et sa configuration flexible en font un excellent choix pour les opérations logistiques.',
      image: 'https://images.unsplash.com/photo-1764705639498-7d982f668c38?auto=format&fit=crop&q=80'
    }
  ],
  transportMedium: [
    { 
      id: 'airbus-c295-transport',
      name: 'Airbus C-295 (Version Transport)', 
      country: 'Espagne', 
      range: '4 300 km', 
      capacity: '45-70 pax', 
      role: 'Transport tactique, parachutage, fret',
      mtow: '23 200 kg',
      speed: '480 km/h',
      ceiling: '30 000 ft',
      crew: '2-3 pilotes',
      engine: '2 × turbopropulseurs Pratt & Whitney PW127G',
      payload: '9 250 kg',
      features: ['Rampe arrière', 'Capacité parachutage', 'Version MPA disponible', 'OTAN compatible'],
      description: 'Le C-295 est l\'avion de transport tactique moderne par excellence. Utilisé par plus de 30 forces aériennes, il combine performance, robustesse et coûts maîtrisés.',
      image: 'https://images.unsplash.com/photo-1715542608092-40b1f6f638b4?auto=format&fit=crop&q=80'
    },
    { 
      id: 'leonardo-c27j-spartan',
      name: 'Leonardo C-27J Spartan', 
      country: 'Italie', 
      range: '> 4 000 km', 
      capacity: '~60 soldats', 
      role: 'Transport tactique rustique, largage, pistes courtes',
      mtow: '31 800 kg',
      speed: '590-600 km/h',
      ceiling: '30 000 ft',
      crew: '2-3 pilotes',
      engine: '2 × turbopropulseurs Rolls-Royce AE 2100-D2A',
      payload: '11 500 kg',
      features: ['Cellule très robuste', 'Performances STOL', 'Opérations austères', 'Interopérable C-130'],
      description: 'Le C-27J partage de nombreux systèmes avec le C-130J, garantissant une interopérabilité optimale. Sa cellule robuste et ses capacités STOL en font l\'appareil idéal pour opérations dans environnements austères.',
      image: 'https://images.unsplash.com/photo-1572818708328-eb9a8338c8ef?auto=format&fit=crop&q=80'
    },
    { 
      id: 'embraer-kc390',
      name: 'Embraer KC-390 Millennium', 
      country: 'Brésil', 
      range: '6 000 km', 
      capacity: '~80 pax', 
      role: 'Transport lourd, multirôle, ravitaillement',
      mtow: '87 000 kg',
      speed: '870 km/h',
      ceiling: '36 000 ft',
      crew: '2 pilotes + 1 opérateur cargo',
      engine: '2 × turboréacteurs IAE V2500-E5',
      payload: '26 000 kg',
      features: ['Plus rapide que C-130', 'Ravitaillement en vol', 'Avionique moderne', 'Fly-by-wire'],
      description: 'Le KC-390 représente une nouvelle génération de transport militaire. Propulsé par jets, il est significativement plus rapide que les turbopropulseurs et offre ravitaillement en vol, transport lourd et missions multirôles.',
      image: 'https://images.unsplash.com/photo-1694405757542-a5889c9e0160?auto=format&fit=crop&q=80'
    },
    { 
      id: 'lockheed-c130j',
      name: 'Lockheed Martin C-130J Super Hercules', 
      country: 'États-Unis', 
      range: '5 200 km', 
      capacity: '90+ pax / fret', 
      role: 'Transport tactique & stratégique',
      mtow: '79 380 kg',
      speed: '670 km/h',
      ceiling: '33 000 ft',
      crew: '2 pilotes + 1 mécanicien navigant',
      engine: '4 × turbopropulseurs Rolls-Royce AE 2100D3',
      payload: '20 000 kg',
      features: ['Standard mondial', 'Très polyvalent', 'Éprouvé au combat', 'Support mondial'],
      description: 'Le C-130J Super Hercules est l\'avion de transport militaire le plus utilisé au monde. Sa polyvalence, sa fiabilité éprouvée et son réseau de support mondial en font un choix privilégié.',
      image: 'https://images.unsplash.com/photo-1695314871108-5ee71496213e?auto=format&fit=crop&q=80'
    },
    { 
      id: 'antonov-an32',
      name: 'Antonov An-32', 
      country: 'Ukraine', 
      range: '2 500 km', 
      capacity: '~42 pax', 
      role: 'Transport rustique, pistes sommaires',
      mtow: '27 000 kg',
      speed: '530 km/h',
      ceiling: '29 500 ft',
      crew: '2-3 pilotes',
      engine: '2 × turbopropulseurs Progress AI-20D',
      payload: '6 700 kg',
      features: ['Très rustique', 'Pistes non préparées', 'Climat chaud', 'Coûts bas'],
      description: 'L\'An-32 est optimisé pour opérations en haute altitude et climats chauds. Conçu pour fonctionner avec un minimum d\'infrastructures au sol, il excelle sur pistes non préparées.',
      image: 'https://images.pexels.com/photos/31242590/pexels-photo-31242590.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'dash8-400',
      name: 'De Havilland Dash 8-400', 
      country: 'Canada', 
      range: '2 000-2 100 km', 
      capacity: '74-78 places', 
      role: 'Transport régional troupes et fret',
      mtow: '29 260 kg',
      speed: '660-670 km/h',
      ceiling: '25 000 ft',
      crew: '2 pilotes',
      engine: '2 × turbopropulseurs Pratt & Whitney PW150A',
      payload: '8 000 kg',
      features: ['Excellente fiabilité', 'Coûts optimisés', 'Configuration militaire', 'Très répandu'],
      description: 'Basé sur l\'avion civil très répandu, le Dash 8-400 offre une excellente fiabilité et des coûts d\'exploitation optimisés. Aménageable en configuration militaire pour transport de troupes et cargo.',
      image: 'https://images.unsplash.com/photo-1670572157793-cb24dc09278e?auto=format&fit=crop&q=80'
    }
  ],
  training: [
    { 
      id: 'kai-kt1-woongbi',
      name: 'KAI KT-1 Woongbi', 
      country: 'Corée du Sud', 
      range: '1 300-1 400 km', 
      speed: '500-520 km/h', 
      role: 'Entraînement de base et intermédiaire, léger appui armé',
      mtow: '3 300 kg',
      ceiling: '11 600 m',
      crew: '2 (élève + instructeur)',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-62',
      armament: 'Points d\'emport pour armement léger',
      features: ['Cockpit tandem', 'Instrumentation moderne', 'Formation COIN', 'Économique'],
      description: 'Le KT-1 Woongbi est un avion d\'entraînement moderne avec cockpit en tandem. Capable d\'intégrer des équipements d\'armement léger, il peut aussi servir pour formation COIN de base.',
      image: 'https://images.unsplash.com/photo-1723873293244-ffb3d3eb9b46?auto=format&fit=crop&q=80'
    },
    { 
      id: 'beechcraft-t6-texan-ii',
      name: 'Beechcraft T-6 Texan II', 
      country: 'États-Unis', 
      range: '1 600 km', 
      speed: '585 km/h', 
      role: 'Entraînement avancé',
      mtow: '2 948 kg',
      ceiling: '31 000 ft',
      crew: '2 (élève + instructeur)',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-68',
      features: ['Standard OTAN', 'Avionique moderne', 'HUD', 'Très répandu'],
      description: 'Le T-6 Texan II est l\'avion d\'entraînement avancé standard pour de nombreuses forces aériennes. Son cockpit moderne avec HUD prépare efficacement les pilotes aux avions de combat.',
      image: 'https://images.unsplash.com/photo-1647085442806-4c605a5bf4db?auto=format&fit=crop&q=80'
    },
    { 
      id: 'pilatus-pc21',
      name: 'Pilatus PC-21', 
      country: 'Suisse', 
      range: '1 330 km', 
      speed: '685 km/h', 
      role: 'Préparation au jet, entraînement avancé',
      mtow: '3 200 kg',
      ceiling: '38 000 ft',
      crew: '2 (élève + instructeur)',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-68B',
      features: ['Plus rapide turboprop entraînement', 'Cockpit chasseur', 'Performances exceptionnelles', 'Pressurisation'],
      description: 'Le PC-21 est considéré comme le meilleur avion d\'entraînement turbopropulsé au monde. Son cockpit reproduit celui d\'un chasseur moderne et ses performances permettent transition optimale vers jets.',
      image: 'https://images.unsplash.com/photo-1723873293244-ffb3d3eb9b46?auto=format&fit=crop&q=80'
    },
    { 
      id: 'grob-g120tp',
      name: 'Grob G 120TP', 
      country: 'Allemagne', 
      range: '1 800-1 900 km', 
      speed: '390-410 km/h', 
      role: 'Entraînement de base, transition turbopropulseurs',
      mtow: '1 800 kg',
      ceiling: '7 600-8 000 m',
      crew: '2 (tandem)',
      engine: '1 × turbopropulseur Rolls-Royce M250-B17F',
      glimits: '+6 g / -4 g',
      features: ['Avion léger', 'Économique', 'Parfait ab initio', 'Manœuvres base'],
      description: 'Le G 120TP est un excellent avion d\'entraînement de base. Léger et économique, il permet l\'apprentissage des manœuvres fondamentales et la transition vers turbopropulseurs plus puissants.',
      image: 'https://images.unsplash.com/photo-1751842959689-6743a0846aa5?auto=format&fit=crop&q=80'
    },
    { 
      id: 'leonardo-m345',
      name: 'Leonardo M-345', 
      country: 'Italie', 
      range: '1 300-1 500 km', 
      speed: '650-700 km/h', 
      role: 'Jet d\'entraînement de base et intermédiaire',
      mtow: '4 500-5 000 kg',
      ceiling: '12 000-13 000 m',
      crew: '2 (tandem)',
      engine: '1 × turboréacteur Williams FJ44',
      features: ['Cockpit moderne', 'Écrans multifonctions', 'HUD', 'Consommation réduite'],
      description: 'Le M-345 est un jet d\'entraînement moderne avec avionique de dernière génération. Plus économique que les anciens jets, il offre excellente plateforme pour remplacer plateformes vieillissantes.',
      image: 'https://images.unsplash.com/photo-1579584925440-96636d517983?auto=format&fit=crop&q=80'
    },
    { 
      id: 'embraer-a29-super-tucano-trainer',
      name: 'Embraer A-29 Super Tucano (Version Entraînement)', 
      country: 'Brésil', 
      range: '1 330 km', 
      speed: '590 km/h', 
      role: 'Entraînement avancé et appui au sol',
      mtow: '3 810 kg',
      ceiling: '35 000 ft',
      crew: '2',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-68C',
      features: ['Polyvalent entraînement/COIN', 'Avionique moderne', 'Blindage disponible', 'Éprouvé'],
      description: 'Le Super Tucano en version entraînement offre transition idéale vers opérations COIN. Plateforme polyvalente permettant formation complète des pilotes sur avion armé.',
      image: 'https://images.pexels.com/photos/19369660/pexels-photo-19369660.jpeg?auto=compress&cs=tinysrgb&w=1200'
    }
  ],
  coin: [
    { 
      id: 'embraer-a29-super-tucano',
      name: 'Embraer A-29 Super Tucano', 
      country: 'Brésil', 
      range: '1 330 km', 
      speed: '590 km/h', 
      role: 'Appui au sol, ISR armé',
      mtow: '3 810 kg',
      ceiling: '35 000 ft',
      crew: '2',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-68C',
      payload: '1 550 kg',
      armament: 'Mitrailleuses 12.7mm, roquettes, bombes guidées/non guidées',
      features: ['Éprouvé au combat', 'Blindage cockpit', 'Capteurs ISR', 'Coûts très bas'],
      description: 'Le Super Tucano est l\'appareil COIN de référence mondiale. Utilisé dans plus de 15 pays, il combine armement léger, capacités ISR et coûts opérationnels très réduits.',
      image: 'https://images.pexels.com/photos/19369660/pexels-photo-19369660.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'beechcraft-at6-wolverine',
      name: 'Beechcraft AT-6 Wolverine', 
      country: 'États-Unis', 
      range: '1 600 km', 
      speed: '585 km/h', 
      role: 'Appui & reconnaissance armée',
      mtow: '2 948 kg',
      ceiling: '31 000 ft',
      crew: '2',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-68',
      payload: '680 kg armement',
      armament: 'Points d\'emport pour missiles, roquettes, bombes guidées',
      features: ['Basé sur T-6 Texan II', 'Capteurs avancés', 'Liaison données', 'Support américain'],
      description: 'Dérivé du T-6 Texan II, l\'AT-6 Wolverine est optimisé pour missions COIN et reconnaissance armée. Il combine avionique moderne, capteurs avancés et capacités d\'armement.',
      image: 'https://images.unsplash.com/photo-1599719014003-d0c8a7e60a99?auto=format&fit=crop&q=80'
    },
    { 
      id: 'ahrlac-mwari',
      name: 'Bronco II (AHRLAC/Mwari)', 
      country: 'Afrique du Sud / États-Unis', 
      endurance: '6-7 heures', 
      speed: '460-500 km/h', 
      role: 'ISR armé, COIN, surveillance de zone',
      engine: '1 × turbopropulseur (~1 000 shp)',
      payload: 'Plusieurs centaines de kg',
      armament: 'Points d\'emport modulaires armement et capteurs',
      features: ['Conception dédiée ISR/COIN', 'Visibilité excellente', 'Maintenance simplifiée', 'Architecture modulaire'],
      description: 'Le Mwari est conçu spécifiquement pour missions ISR et COIN. Son architecture modulaire, son excellent champ de vision et sa maintenance simple en font plateforme idéale pour surveillance armée.',
      image: 'https://images.unsplash.com/photo-1569798546658-3181e3dde671?auto=format&fit=crop&q=80'
    },
    { 
      id: 'at802l-longsword',
      name: 'AT-802L Longsword', 
      country: 'États-Unis', 
      endurance: 'jusqu\'à 8 heures', 
      speed: '330-370 km/h', 
      role: 'COIN, surveillance armée, lutte contre trafics',
      mtow: '7 200-7 300 kg',
      payload: 'jusqu\'à 4 000 kg',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-67F',
      armament: 'Points d\'emport multiples armement léger/moyen',
      features: ['Très rustique', 'Vol lent longue durée', 'Coûts extrêmement bas', 'Grande endurance'],
      description: 'Dérivé d\'un avion agricole, l\'AT-802L Longsword est extrêmement rustique et économique. Sa capacité à voler lentement pendant longues heures en fait excellent choix surveillance armée.',
      image: 'https://images.unsplash.com/photo-1709873582544-8758736dc781?auto=format&fit=crop&q=80'
    },
    { 
      id: 'pilatus-pc9-mkii',
      name: 'Pilatus PC-9 Mk II', 
      country: 'Suisse', 
      range: '1 500 km', 
      speed: '590-610 km/h', 
      role: 'Entraînement avancé et COIN léger',
      mtow: '3 200-3 300 kg',
      ceiling: '11 500 m',
      crew: '2 (tandem)',
      engine: '1 × turbopropulseur PT6A-62',
      armament: 'Points d\'emport roquettes, bombes légères, pods armes',
      features: ['Plateforme entraînement réputée', 'COIN basse intensité', 'Maniable', 'Fiable'],
      description: 'Le PC-9 combine entraînement avancé et capacités COIN légères. Dérivé d\'une plateforme d\'entraînement éprouvée, bonne solution pour appui léger en conflits basse intensité.',
      image: 'https://images.unsplash.com/photo-1763992522157-a1f43f5b9bb6?auto=format&fit=crop&q=80'
    },
    { 
      id: 'iomax-archangel',
      name: 'IOMAX Archangel (AT-802U)', 
      country: 'États-Unis', 
      range: '2 000 km', 
      speed: '350 km/h', 
      role: 'Appui léger, surveillance armée',
      mtow: '7 300 kg',
      endurance: '10+ heures',
      crew: '2',
      engine: '1 × turbopropulseur Pratt & Whitney PT6A-67',
      payload: '4 000 kg',
      armament: 'Armement léger/moyen, capteurs ISR',
      features: ['Très longue endurance', 'Rustique', 'Économique', 'Opérations prolongées'],
      description: 'L\'Archangel est version militarisée de l\'Air Tractor agricole. Extrêmement rustique et économique, il peut voler très longtemps à basse vitesse, idéal surveillance vastes zones.',
      image: 'https://images.unsplash.com/photo-1564499333540-9b5a68ba9a19?auto=format&fit=crop&q=80'
    }
  ],
  helicoptersLight: [
    { 
      id: 'airbus-h135m',
      name: 'Airbus H135M', 
      country: 'France', 
      range: '630-650 km', 
      capacity: '5-6 pax', 
      role: 'Entraînement, police, surveillance, HEMS léger',
      mtow: '2 900-3 000 kg',
      speed: '250-260 km/h',
      crew: '1-2 pilotes',
      engine: '2 × turbines Pratt & Whitney PW206B3 ou Safran Arrius',
      features: ['Bimoteur compact', 'Missions parapubliques', 'Formation', 'Sûreté intérieure'],
      description: 'Le H135M est un hélicoptère léger bimoteur très répandu pour missions parapubliques. Compact et polyvalent, idéal pour formation, police, surveillance et missions médicales légères.',
      image: 'https://images.unsplash.com/photo-1671116607892-7175c0ccdb4b?auto=format&fit=crop&q=80'
    },
    { 
      id: 'airbus-h125m',
      name: 'Airbus H125M', 
      country: 'France', 
      range: '650 km', 
      capacity: '~5 pax', 
      role: 'Reconnaissance, évacuation, liaison',
      mtow: '2 250 kg',
      speed: '245 km/h',
      crew: '1 pilote',
      engine: '1 × turbine Safran Arriel 2D',
      payload: '1 400 kg',
      features: ['Mono-turbine fiable', 'Haute altitude', 'Version armée possible', 'Très maniable'],
      description: 'Le H125M (anciennement Écureuil/Fennec) est un hélicoptère léger monomoteur robuste. Excellent en haute altitude et climats chauds, disponible en version armée pour reconnaissance et appui léger.',
      image: 'https://images.unsplash.com/photo-1648110575888-5257b57f9d6e?auto=format&fit=crop&q=80'
    },
    { 
      id: 'airbus-h145m',
      name: 'Airbus H145M', 
      country: 'Allemagne', 
      range: '640 km', 
      capacity: '~8 pax', 
      role: 'Forces spéciales, MEDEVAC, appui',
      mtow: '3 700 kg',
      speed: '250 km/h',
      crew: '1-2 pilotes',
      engine: '2 × turbines Safran Arriel 2E',
      payload: '1 700 kg',
      features: ['Configuration forces spéciales', 'Treuil sauvetage', 'Vision nocturne', 'Armement possible'],
      description: 'Le H145M est optimisé pour forces spéciales et missions tactiques. Équipé pour vision nocturne, avec possibilité d\'armement et de treuil, c\'est une plateforme très capable.',
      image: 'https://images.unsplash.com/photo-1635764963325-f1d93ca922a3?auto=format&fit=crop&q=80'
    },
    { 
      id: 'bell-407gxi',
      name: 'Bell 407GXi', 
      country: 'États-Unis', 
      range: '600-620 km', 
      capacity: '6 pax', 
      role: 'Transport léger, observation, surveillance',
      mtow: '2 270 kg',
      speed: '240-250 km/h',
      crew: '1 pilote',
      engine: '1 × turbine Rolls-Royce 250-C47E',
      payload: '680 kg',
      features: ['Mono-turbine moderne', 'Très fiable', 'Polyvalent', 'Avionique Garmin G1000'],
      description: 'Le Bell 407GXi est un hélicoptère mono-turbine moderne très apprécié. Équipé d\'une avionique Garmin G1000 NXi, il offre fiabilité et polyvalence pour transport léger et surveillance.',
      image: 'https://images.unsplash.com/photo-1716918267272-8e3e81c9d836?auto=format&fit=crop&q=80'
    },
    { 
      id: 'bell-429',
      name: 'Bell 429', 
      country: 'Canada', 
      range: '720-730 km', 
      capacity: 'jusqu\'à 7 pax', 
      role: 'Missions publiques, police, HEMS, transport VIP',
      mtow: '3 175-3 200 kg',
      speed: '275-280 km/h',
      crew: '1-2 pilotes',
      engine: '2 × turbines Pratt & Whitney PW207D1',
      features: ['Cabine spacieuse', 'Missions médicales', 'Sûreté', 'Confort VIP'],
      description: 'Le Bell 429 offre cabine spacieuse et excellent confort. Bimoteur fiable, excellente plateforme pour missions médicales, police et transport VIP léger.',
      image: 'https://images.unsplash.com/photo-1742931897852-233e8d38b5fc?auto=format&fit=crop&q=80'
    },
    { 
      id: 'md-helicopters-md530g',
      name: 'MD Helicopters MD 530G', 
      country: 'États-Unis', 
      range: '400 km', 
      capacity: '4-5 pax', 
      role: 'Reconnaissance armée, appui léger',
      mtow: '1 660 kg',
      speed: '260 km/h',
      crew: '1-2',
      engine: '1 × turbine Rolls-Royce 250-C30',
      armament: 'Mitrailleuses, roquettes, missiles légers',
      features: ['Petit et agile', 'Version armée', 'Faible coût', 'Opérations urbaines'],
      description: 'Le MD 530G est un hélicoptère léger d\'attaque. Petit, agile et armé, il est parfait pour reconnaissance armée, appui feu léger et opérations en zones urbaines.',
      image: 'https://images.unsplash.com/photo-1623276070936-4be8f0b8f3d0?auto=format&fit=crop&q=80'
    }
  ],
  helicoptersMedium: [
    { 
      id: 'bell-412epx',
      name: 'Bell 412EPX', 
      country: 'États-Unis', 
      range: '740-750 km', 
      capacity: '~13 pax', 
      role: 'Transport tactique moyen, SAR, missions parapubliques',
      mtow: '5 400 kg',
      speed: '240-260 km/h',
      crew: '1-2 pilotes',
      engine: '2 × turbines Pratt & Whitney PT6T-9 (turbine jumelée)',
      payload: '2 000 kg',
      features: ['Dérivé modernisé Bell 412', 'Très robuste', 'Largement utilisé', 'Support mondial'],
      description: 'Le Bell 412EPX est la version modernisée du célèbre Bell 412. Robuste et fiable, il est utilisé par nombreuses forces armées et civiles pour transport tactique et SAR.',
      image: 'https://images.unsplash.com/photo-1728719812207-2ad4640ac986?auto=format&fit=crop&q=80'
    },
    { 
      id: 'mi-171sh',
      name: 'Mi-171Sh', 
      country: 'Russie', 
      range: '600 km', 
      capacity: '~20 pax', 
      role: 'Transport lourd & appui',
      mtow: '13 000 kg',
      speed: '250 km/h',
      crew: '2-3',
      engine: '2 × turbines Klimov TV3-117VM',
      payload: '4 000 kg',
      armament: 'Points d\'emport pour roquettes et mitrailleuses',
      features: ['Grande capacité', 'Très robuste', 'Version militaire', 'Coûts modérés'],
      description: 'Le Mi-171Sh est la version militaire du Mi-17. Avec sa grande capacité de transport et sa robustesse légendaire, il peut également être armé pour missions d\'appui.',
      image: 'https://images.pexels.com/photos/919580/pexels-photo-919580.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'aw139m',
      name: 'Leonardo AW139M', 
      country: 'Italie', 
      range: '1 060 km', 
      capacity: '~15 pax', 
      role: 'SAR, transport tactique, missions spéciales',
      mtow: '7 000 kg',
      speed: '285 km/h',
      crew: '1-2 pilotes',
      engine: '2 × turbines Pratt & Whitney PT6C-67C',
      payload: '2 500 kg',
      features: ['Très polyvalent', 'Grande cabine', 'Missions SAR', 'Support mondial'],
      description: 'L\'AW139M est un hélicoptère moyen très polyvalent. Sa grande cabine et son rayon d\'action étendu en font excellente plateforme pour SAR maritime et terrestre.',
      image: 'https://images.pexels.com/photos/34266473/pexels-photo-34266473.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'nh90-tth',
      name: 'NH90 TTH', 
      country: 'Europe (consortium)', 
      range: '800 km', 
      capacity: 'jusqu\'à 20 soldats', 
      role: 'Transport tactique de troupes, missions d\'assaut',
      mtow: '10 600-11 000 kg',
      speed: '260 km/h',
      crew: '2 pilotes',
      engine: '2 × turbines RTM322 ou GE T700',
      payload: '2 500 kg',
      features: ['Nouvelle génération', 'Avionique très avancée', 'Standard européen', 'Capacité d\'assaut'],
      description: 'Le NH90 est l\'hélicoptère de transport tactique de nouvelle génération européen. Doté avionique très avancée, intensivement employé par plusieurs armées européennes.',
      image: 'https://images.unsplash.com/photo-1732891101115-5318b438fecd?auto=format&fit=crop&q=80'
    },
    { 
      id: 'leonardo-aw149',
      name: 'Leonardo AW149', 
      country: 'Italie', 
      range: '900-1 000 km', 
      capacity: 'jusqu\'à 18 soldats', 
      role: 'Transport tactique, appui, SAR, missions spéciales',
      mtow: '8 300-8 600 kg',
      speed: '280-290 km/h',
      crew: '1-2 pilotes',
      engine: '2 × turbines GE CT7-2E1',
      payload: '3 000 kg',
      features: ['Plateforme moderne', 'Alternative Black Hawk/NH90', 'Bon compromis performance/coût', 'Configuration tactique'],
      description: 'L\'AW149 est plateforme moderne offrant alternative aux Black Hawk et NH90. Avec bon compromis performance/coût, idéal pour transport tactique et missions spéciales.',
      image: 'https://images.unsplash.com/photo-1635764963325-f1d93ca922a3?auto=format&fit=crop&q=80'
    },
    { 
      id: 'airbus-h215m',
      name: 'Airbus H215M (Super Puma)', 
      country: 'France', 
      range: '860 km', 
      capacity: '~20 pax', 
      role: 'Transport lourd, SAR, missions offshore',
      mtow: '11 000 kg',
      speed: '260 km/h',
      crew: '2 pilotes',
      engine: '2 × turbines Safran Makila 1A1',
      payload: '4 500 kg',
      features: ['Grande capacité', 'Version navalisée disponible', 'SAR longue portée', 'Très robuste'],
      description: 'Le Super Puma H215M est un hélicoptère lourd de référence. Avec grande capacité et robustesse, il excelle en SAR, transport offshore et missions de longue durée.',
      image: 'https://images.pexels.com/photos/17751856/pexels-photo-17751856.jpeg?auto=compress&cs=tinysrgb&w=1200'
    }
  ],
  maritime: [
    { 
      id: 'dash8-mpa',
      name: 'Dash 8 Q300/Q400 MPA', 
      country: 'Canada', 
      endurance: '8-10 heures', 
      role: 'Patrouille maritime, SAR, surveillance côtière',
      engine: '2 × turbopropulseurs PW123 (Q300) ou PW150A (Q400)',
      sensors: 'Radar maritime, boule EO/IR, ESM, liaisons données',
      features: ['Cellule très répandue', 'Logistique facilitée', 'Volume cabine', 'Consoles opérateurs'],
      description: 'Basé sur Dash 8 civils très répandus, cette version MPA offre excellente plateforme pour patrouille maritime avec endurance 8-10 heures et volume suffisant pour équipements et opérateurs.',
      image: 'https://images.unsplash.com/photo-1661025204506-2ef383fc3f52?auto=format&fit=crop&q=80'
    },
    { 
      id: 'dornier-228-mp',
      name: 'Dornier 228 MP', 
      country: 'Allemagne', 
      range: '2 000-2 300 km', 
      role: 'Patrouille maritime légère, surveillance côtière',
      mtow: '6 400-6 600 kg',
      speed: '390-410 km/h',
      engine: '2 × turbopropulseurs Honeywell TPE331-10',
      sensors: 'Radar de surface, boule EO/IR, équipements mission',
      features: ['Avion compact', 'Économique', 'Capacité STOL', 'Première capacité MPA'],
      description: 'Le Dornier 228 MP est avion patrouille maritime léger et économique. Avec capacités STOL et format compact, très adapté comme première capacité MPA pour État côtier.',
      image: 'https://images.pexels.com/photos/12412707/pexels-photo-12412707.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'cn235-mpa',
      name: 'CN-235 MPA', 
      country: 'Espagne/Indonésie', 
      endurance: '7-8 heures', 
      role: 'Patrouille maritime, surveillance ZEE, SAR',
      engine: '2 × turbopropulseurs GE CT7-9C',
      sensors: 'Radar maritime, boule EO/IR, liaisons données, bouées acoustiques',
      features: ['Taille intermédiaire', 'Budgets moyens', 'Adaptation littoral', 'Version éprouvée'],
      description: 'Version maritime du CN-235 de transport, ce MPA offre endurance 7-8 heures et capacités complètes surveillance maritime. Compatible budgets moyens, bien adapté littoral africain.',
      image: 'https://images.pexels.com/photos/16600245/pexels-photo-16600245.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'atr-72-mpa',
      name: 'ATR 72 MPA', 
      country: 'Italie', 
      range: '3 800 km', 
      role: 'Surveillance côtière, patrouille ZEE',
      endurance: '8 heures',
      engine: '2 × turbopropulseurs Pratt & Whitney PW127',
      sensors: 'Radar longue portée, EO/IR, FLIR, liaison tactique',
      features: ['Grande autonomie', 'Cabine spacieuse', 'Système mission avancé', 'Cellule civile éprouvée'],
      description: 'L\'ATR 72 MPA est basé sur avion régional civil très répandu. Sa grande cabine permet installation complète systèmes mission et postes opérateurs pour patrouille maritime efficace.',
      image: 'https://images.unsplash.com/photo-1706723532458-392730ad1277?auto=format&fit=crop&q=80'
    },
    { 
      id: 'beechcraft-king-air-350er-mpa',
      name: 'Beechcraft King Air 350ER MPA', 
      country: 'États-Unis', 
      range: '4 400 km', 
      role: 'Surveillance côtière légère, reconnaissance maritime',
      endurance: '6-7 heures',
      engine: '2 × turbopropulseurs Pratt & Whitney PT6A-60A',
      sensors: 'Radar maritime, boule EO/IR, liaison données',
      features: ['Plateforme compacte', 'Économique', 'Bonne autonomie', 'Facile déploiement'],
      description: 'Version MPA du King Air 350, offrant solution compacte et économique pour surveillance maritime. Idéal pour pays recherchant première capacité MPA avec coûts maîtrisés.',
      image: 'https://images.unsplash.com/photo-1660968601185-e7414de388f4?auto=format&fit=crop&q=80'
    },
    { 
      id: 'airbus-c295-mpa',
      name: 'Airbus C-295 MPA', 
      country: 'Espagne', 
      endurance: '10+ heures', 
      role: 'Patrouille maritime longue portée, ASW',
      engine: '2 × turbopropulseurs Pratt & Whitney PW127G',
      sensors: 'Radar maritime, MAD, bouées acoustiques, EO/IR, ESM',
      features: ['Endurance maximale', 'Capacité ASW complète', 'Grande cabine mission', 'Standard OTAN'],
      description: 'Le C-295 MPA est plateforme MPA de référence. Avec endurance 10+ heures et capacités ASW complètes (guerre sous-marine), système très capable pour surveillance maritime étendue.',
      image: 'https://images.unsplash.com/photo-1715542608092-40b1f6f638b4?auto=format&fit=crop&q=80'
    }
  ],
  drones: [
    { 
      id: 'bayraktar-tb2',
      name: 'Bayraktar TB2', 
      country: 'Turquie', 
      endurance: '~24h', 
      payload: '~150 kg', 
      role: 'ISR + frappes',
      mtow: '700 kg',
      ceiling: '25 000 ft',
      wingspan: '12 m',
      sensors: 'Boule EO/IR, désignateur laser',
      armament: 'Missiles guidés légers (MAM-L, MAM-C)',
      features: ['Coût très compétitif', 'Éprouvé au combat', 'Facile déploiement', 'Formation simple'],
      description: 'Le TB2 a révolutionné le marché des drones MALE armés. Avec son coût très compétitif et son efficacité prouvée dans plusieurs conflits, c\'est le drone tactique le plus exporté au monde.',
      image: 'https://images.unsplash.com/photo-1693736688941-bf50a187df26?auto=format&fit=crop&q=80'
    },
    { 
      id: 'bayraktar-akinci',
      name: 'Bayraktar Akıncı', 
      country: 'Turquie', 
      endurance: '~24h', 
      payload: '~1 500 kg', 
      role: 'Drone MALE lourd armé',
      mtow: '6 000 kg',
      ceiling: '40 000 ft',
      wingspan: '20 m',
      engine: '2 × turbopropulseurs',
      sensors: 'Radar AESA, EO/IR, SIGINT, liaison satellite',
      armament: 'Missiles air-sol, bombes guidées, armement lourd',
      features: ['Capacité armement lourd', 'Altitude élevée', 'Missions stratégiques', 'Radar AESA'],
      description: 'L\'Akıncı est drone MALE lourd de nouvelle génération. Avec capacité emport armement guidé lourd, radar AESA et liaison satellite, il peut conduire missions stratégiques complexes.',
      image: 'https://images.unsplash.com/photo-1693736688941-bf50a187df26?auto=format&fit=crop&q=80'
    },
    { 
      id: 'wing-loong-ii',
      name: 'Wing Loong II', 
      country: 'Chine', 
      endurance: '~20h', 
      payload: '400-500 kg', 
      role: 'Drone MALE armé',
      mtow: '4 200 kg',
      ceiling: '30 000-33 000 ft',
      wingspan: '20,5 m',
      sensors: 'Boule EO/IR, radar, datalink',
      armament: 'Missiles air-sol légers, bombes guidées',
      features: ['Coût acquisition contenu', 'Déjà exporté', 'Capacités ISR et frappe', 'Support chinois'],
      description: 'Le Wing Loong II est solution MALE armée avec coût acquisition relativement contenu. Déjà exporté dans plusieurs pays, offre bonnes capacités ISR et frappe.',
      image: 'https://images.pexels.com/photos/3876430/pexels-photo-3876430.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'mq9-reaper',
      name: 'MQ-9 Reaper', 
      country: 'États-Unis', 
      endurance: '~27h', 
      payload: '~1 700 kg', 
      role: 'ISR stratégique & frappes',
      mtow: '4 760 kg',
      ceiling: '50 000 ft',
      wingspan: '20 m',
      sensors: 'Radar SAR/GMTI, EO/IR multi-spectral, SIGINT',
      armament: 'Missiles Hellfire, bombes guidées GBU, armement varié',
      features: ['Référence mondiale MALE', 'Capteurs ultra-avancés', 'Grande endurance', 'Armement lourd'],
      description: 'Le MQ-9 Reaper est drone MALE de référence mondiale. Avec capteurs ultra-avancés, armement lourd et endurance exceptionnelle, peut conduire missions ISR stratégiques et frappes de précision.',
      image: 'https://images.unsplash.com/photo-1707660640350-33559c42d6e7?auto=format&fit=crop&q=80'
    },
    { 
      id: 'iai-heron-tp',
      name: 'IAI Heron TP', 
      country: 'Israël', 
      endurance: '30-36h', 
      payload: '~1 000 kg', 
      role: 'Drone MALE lourd surveillance stratégique',
      mtow: '5 400-5 700 kg',
      ceiling: '45 000 ft',
      wingspan: '26 m',
      sensors: 'Radar, EO/IR, systèmes SIGINT/COMINT',
      features: ['Très forte endurance', 'Surveillance stratégique', 'Charges multiples', 'Altitude élevée'],
      description: 'Le Heron TP offre endurance exceptionnelle de 30-36 heures. Avec capacités SIGINT/COMINT et plafond élevé, c\'est plateforme surveillance stratégique de premier ordre.',
      image: 'https://images.unsplash.com/photo-1508614999368-9260051292e5?auto=format&fit=crop&q=80'
    },
    { 
      id: 'general-atomics-gray-eagle',
      name: 'General Atomics MQ-1C Gray Eagle', 
      country: 'États-Unis', 
      endurance: '25h', 
      payload: '~450 kg', 
      role: 'ISR tactique et frappe',
      mtow: '1 633 kg',
      ceiling: '29 000 ft',
      wingspan: '17 m',
      sensors: 'Radar SAR/GMTI, EO/IR, laser',
      armament: 'Missiles Hellfire, bombes GBU',
      features: ['Version US Army', 'Capteurs avancés', 'Liaison satellite', 'Intégration C4ISR'],
      description: 'Le Gray Eagle est version US Army du Predator. Optimisé pour ISR tactique et frappe de précision, il s\'intègre parfaitement dans systèmes C4ISR modernes.',
      image: 'https://images.unsplash.com/photo-1527977966376-1c8408f9f108?auto=format&fit=crop&q=80'
    }
  ],
  vip: [
    { 
      id: 'embraer-phenom-300e',
      name: 'Embraer Phenom 300E', 
      country: 'Brésil', 
      range: '3 600-3 700 km', 
      capacity: '6-8 pax', 
      role: 'Jet d\'affaires léger',
      speed: 'Mach 0,78-0,80',
      ceiling: '45 000 ft',
      crew: '2 pilotes',
      engine: '2 × turboréacteurs Pratt & Whitney PW535E1',
      features: ['Très répandu', 'Coûts maîtrisés', 'Missions régionales', 'Avionique Prodigy Touch'],
      description: 'Le Phenom 300E est le jet léger le plus livré au monde. Avec coûts d\'exploitation maîtrisés et avionique moderne, idéal pour missions régionales et continentales.',
      image: 'https://images.pexels.com/photos/14983522/pexels-photo-14983522.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'cessna-citation-cj4',
      name: 'Cessna Citation CJ4', 
      country: 'États-Unis', 
      range: '3 700 km', 
      capacity: '~10 pax', 
      role: 'Missions gouvernementales, transport exécutif',
      speed: 'Mach 0,77',
      ceiling: '45 000 ft',
      crew: '2 pilotes',
      engine: '2 × turboréacteurs Williams FJ44-4A',
      features: ['Cabine spacieuse', 'Avionique Garmin G3000', 'Fiabilité Cessna', 'Bonne autonomie'],
      description: 'Le Citation CJ4 offre excellente combinaison de performance et confort. Sa cabine spacieuse et avionique moderne en font choix prisé pour missions gouvernementales.',
      image: 'https://images.unsplash.com/photo-1660968601173-25e63b02bd71?auto=format&fit=crop&q=80'
    },
    { 
      id: 'pilatus-pc24',
      name: 'Pilatus PC-24', 
      country: 'Suisse', 
      range: '3 600 km', 
      capacity: '~10 pax', 
      role: 'VIP, pistes courtes, missions spéciales',
      speed: 'Mach 0,73',
      ceiling: '45 000 ft',
      crew: '1-2 pilotes',
      engine: '2 × turboréacteurs Williams FJ44-4A',
      features: ['Pistes courtes', 'Grande porte cargo', 'Configuration flexible', 'Unique'],
      description: 'Le PC-24 est unique : seul jet capable opérer sur pistes courtes non pavées. Grande porte cargo et configuration flexible permettent missions VIP, cargo et médicales.',
      image: 'https://images.pexels.com/photos/15019497/pexels-photo-15019497.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'dassault-falcon-8x',
      name: 'Dassault Falcon 8X', 
      country: 'France', 
      range: '11 000-12 000 km', 
      capacity: '12-14 pax', 
      role: 'Jet d\'affaires très long rayon (tri-réacteur)',
      speed: 'Mach 0,80-0,90',
      ceiling: '51 000 ft',
      crew: '2-3 pilotes',
      engine: '3 × turboréacteurs Pratt & Whitney PW307D',
      features: ['Très grand rayon', 'Image prestige', 'Liaisons intercontinentales', 'Cabine ultra-luxueuse'],
      description: 'Le Falcon 8X est tri-réacteur ultra-long rayon. Avec autonomie 11 000-12 000 km, permet liaisons intercontinentales sans escale avec confort et prestige maximum.',
      image: 'https://images.unsplash.com/photo-1709796722295-ed9bfd44286e?auto=format&fit=crop&q=80'
    },
    { 
      id: 'bombardier-global-6500',
      name: 'Bombardier Global 6500', 
      country: 'Canada', 
      range: '11 000 km', 
      capacity: '14-16 pax', 
      role: 'Jet d\'affaires long rayon',
      speed: 'Mach 0,85-0,90',
      ceiling: '51 000 ft',
      crew: '2-3 pilotes',
      engine: '2 × turboréacteurs Rolls-Royce Pearl 15',
      features: ['Performance/confort excellent', 'Portée intercontinentale', 'Cabine spacieuse', 'Avionique Vision'],
      description: 'Le Global 6500 offre compromis exceptionnel entre performance, confort cabine et portée intercontinentale. Sa cabine spacieuse et autonomie 11 000 km permettent vols très long rayon.',
      image: 'https://images.pexels.com/photos/11935296/pexels-photo-11935296.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'gulfstream-g280',
      name: 'Gulfstream G280', 
      country: 'États-Unis', 
      range: '6 600 km', 
      capacity: '10 pax', 
      role: 'Jet d\'affaires moyen rayon',
      speed: 'Mach 0,85',
      ceiling: '45 000 ft',
      crew: '2 pilotes',
      engine: '2 × turboréacteurs Honeywell HTF7250G',
      features: ['Performances excellentes', 'Cabine confortable', 'Avionique Rockwell Collins', 'Fiabilité Gulfstream'],
      description: 'Le G280 combine les performances d\'un jet moyen rayon avec le confort et la fiabilité légendaire de Gulfstream. Excellent choix pour missions gouvernementales et VIP.',
      image: 'https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80'
    }
  ],
  medevac: [
    { 
      id: 'pilatus-pc12-ngx-medevac',
      name: 'Pilatus PC-12 NGX Medevac', 
      country: 'Suisse', 
      range: '3 300 km', 
      config: '1-2 civières', 
      role: 'Évacuation sanitaire',
      mtow: '4 740 kg',
      speed: '520 km/h',
      ceiling: '30 000 ft',
      crew: '1-2 pilotes + personnel médical',
      engine: '1 × turbopropulseur Pratt & Whitney PT6E-67XP',
      features: ['Configuration médicale complète', 'Équipements soins avancés', 'Grande autonomie', 'Pressurisation'],
      description: 'Version EVASAN du PC-12 NGX, offrant configuration médicale complète avec 1-2 civières, équipements soins avancés et grande autonomie pour évacuations longue distance.',
      image: 'https://images.unsplash.com/photo-1693835195915-b30cc5ae885c?auto=format&fit=crop&q=80'
    },
    { 
      id: 'king-air-260-medevac',
      name: 'King Air 260 / 360 Medevac', 
      country: 'États-Unis', 
      range: '3 000 km', 
      config: '1-2 civières', 
      role: 'Évacuation sanitaire',
      speed: '550-575 km/h',
      crew: '1-2 pilotes + 1-2 personnel médical',
      engine: '2 × turbopropulseurs Pratt & Whitney PT6A',
      features: ['Bimoteur fiable', 'Largement utilisé EVASAN', 'Équipement médical complet', 'Support mondial'],
      description: 'Version médicalisée des King Air 260/360. Ce bimoteur très fiable est largement utilisé pour EVASAN dans le monde, offrant sécurité et équipements médicaux complets.',
      image: 'https://images.unsplash.com/photo-1660968601185-e7414de388f4?auto=format&fit=crop&q=80'
    },
    { 
      id: 'cessna-citation-xls-medevac',
      name: 'Cessna Citation XLS+ Medevac', 
      country: 'États-Unis', 
      range: '3 600 km', 
      config: '1-2 civières', 
      role: 'EVASAN rapide à réaction',
      speed: 'Mach 0,75',
      ceiling: '45 000 ft',
      crew: '2 pilotes + équipe médicale',
      engine: '2 × turboréacteurs Pratt & Whitney PW545C',
      features: ['Vitesse élevée', 'Pressurisation', 'Réaction rapide', 'Équipement médical avancé'],
      description: 'Version médicalisée du Citation XLS+. Grâce à sa vitesse de jet, permet évacuations sanitaires rapides sur longue distance avec équipement médical de pointe.',
      image: 'https://images.unsplash.com/photo-1758656993556-06ebf022ed3a?auto=format&fit=crop&q=80'
    },
    { 
      id: 'leonardo-aw139-hems',
      name: 'Leonardo AW139 HEMS', 
      country: 'Italie', 
      range: '900-1 000 km', 
      config: '2-4 civières', 
      role: 'Hélicoptère HEMS/SAR',
      mtow: '6 800-7 000 kg',
      speed: '280-290 km/h',
      crew: '2 pilotes + personnel médical',
      engine: '2 × turbines PT6C-67C',
      features: ['Référence HEMS/SAR', 'Grande cabine', 'Rayon action excellent', 'Missions maritimes/terrestres'],
      description: 'L\'AW139 configuré HEMS est référence mondiale pour évacuations sanitaires par hélicoptère. Grande cabine permet 2-4 civières avec équipement complet soins d\'urgence.',
      image: 'https://images.pexels.com/photos/34266473/pexels-photo-34266473.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'airbus-c295-medevac',
      name: 'Airbus C295 Medevac', 
      country: 'Espagne', 
      range: '3 000-4 000 km', 
      config: 'Plusieurs dizaines de civières', 
      role: 'Évacuation sanitaire de masse',
      mtow: '23 200 kg',
      speed: '480 km/h',
      ceiling: '30 000 ft',
      crew: '2-3 pilotes + équipe médicale complète',
      engine: '2 × turbopropulseurs Pratt & Whitney PW127G',
      features: ['Évacuation masse', 'Catastrophes naturelles', 'Postes médicaux multiples', 'Personnel soignant'],
      description: 'Le C295 Medevac permet évacuation sanitaire de masse. Avec capacité plusieurs dizaines civières, postes médicaux et personnel soignant, idéal après catastrophes ou opérations militaires majeures.',
      image: 'https://images.pexels.com/photos/16600245/pexels-photo-16600245.jpeg?auto=compress&cs=tinysrgb&w=1200'
    },
    { 
      id: 'airbus-h145m-hems',
      name: 'Airbus H145M HEMS', 
      country: 'Allemagne', 
      range: '640 km', 
      config: '1-2 civières', 
      role: 'EVASAN tactique, HEMS',
      mtow: '3 700 kg',
      speed: '250 km/h',
      crew: '1-2 pilotes + 1-2 personnel médical',
      engine: '2 × turbines Safran Arriel 2E',
      features: ['Compact et rapide', 'Vision nocturne', 'Treuil médical', 'Configuration HEMS optimale'],
      description: 'Version HEMS du H145M, optimisée pour évacuations sanitaires tactiques. Équipé treuil, vision nocturne et configuration médicale complète pour interventions d\'urgence.',
      image: 'https://images.unsplash.com/photo-1635764963325-f1d93ca922a3?auto=format&fit=crop&q=80'
    }
  ]
};
